import { grey } from "@mui/material/colors";

const styles = {
  primaryButton: {
    backgroundColor: "yellow.main",
    width: "max-content",
    px: 2,
    color: "black",
    "&:hover": {
      backgroundColor: "yellow.main",
    },
    textTransform: "none",
    fontSize: 16,
  },
  secondaryButton: {
    color: "secondary.main",
    textTransform: "none",
  },
  closeButton: {
    color: grey[500],
    fontSize: 14,
    position: "absolute",
    right: 10,
    top: 10,
  },
  itemStyling: {
    py: 1,
    px: 1.5,
    mb: 1,
    borderRadius: 2,
    backgroundColor: "rgba(220,38,38,0.05)",
    border: "1px solid rgba(220,38,38,0.12)",
  },
  boldItemStyling: {
    py: 1.25,
    px: 1.5,
    mb: 1,
    borderRadius: 2,
    backgroundColor: "rgba(220,38,38,0.1)",
    border: "2px solid rgba(220,38,38,0.4)",
    boxShadow: "0 2px 8px rgba(220,38,38,0.12)",
  },
};

export default styles;
